<template>
	<div>
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading">
			<div style="display:flex;align-items:center;justify-content:center;height:100%" @click.stop><van-loading
					size="24px" vertical>{{ $t('language000053') }}</van-loading></div>
		</van-overlay>


		<div class="min-h-screen bg-gray-50 pb-20">

			<div class="fixed top-0 w-full bg-white shadow-md z-50 px-4 py-3"><button @click="queryAppConnectStatus"
					:class="['w-full py-3 rounded-lg',isConnected?'bg-green-500 text-white':'bg-red-500 text-white']">{{ isConnected ? $t('language000421') : $t('language000422') }}</button>
			</div>


			<div class="pt-20 px-4" :class="{ 'opacity-50 pointer-events-none': !isConnected }">

				<div class="bg-white rounded-xl shadow-sm p-4 mb-4">
					<!-- 震动模式：Vibration Mode -->
					<h2 class="text-lg font-bold mb-4">{{ $t('language000424') }}</h2>
					<div class="grid grid-cols-5 gap-2"><button v-for="mode in 10" :key="'vibration-'+mode"
							@click="selectVibrationMode(mode)"
							:class="['py-3 rounded-lg text-sm',vibrationMode===mode?'bg-blue-500 text-white':'bg-gray-100']">{{ $t('language000423') }}{{ mode }}</button>
					</div>
					<!-- 震动状态：Vibration Status -->
					<div class="mt-5 flex items-center justify-between">
						<span>{{ $t('language000424') }}</span><el-switch v-model="vibrationEnabled"
							@change="toggleVibration" active-color="#13ce66" inactive-color="#999"
							:active-text="$t('language000363')"></el-switch>
					</div>
					<div class="mt-5">
						<div class="flex justify-between text-sm text-gray-500 mb-2">
							<!-- 震动强度：Vibration Intensity -->
							<span>{{ $t('language000427') }}</span><span>{{ vibrationIntensity }}</span>
						</div><input type="range" v-model.number="vibrationIntensity" min="0" max="255" class="w-full"
							@input="handleVibrationIntensityChange">
					</div>
				</div>


				<div class="bg-white rounded-xl shadow-sm p-4 mb-4">
					<!-- 电击模式：Electric Shock Mode -->
					<h2 class="text-lg font-bold mb-4">{{ $t('language000437') }}</h2>
					<div class="grid grid-cols-4 gap-2"><button v-for="mode in 4" :key="'electric-'+mode"
							@click="selectElectricMode(mode)"
							:class="['py-3 rounded-lg text-sm',electricMode===mode?'bg-pink-500 text-white':'bg-gray-100']">{{ $t('language000423') }}{{ mode }}</button>
					</div>
					<!-- 电击状态：Electric Shock Status -->
					<div class="mt-5 flex items-center justify-between">
						<span>{{ $t('language000437') }}</span><el-switch v-model="electricEnabled"
							@change="toggleElectric" active-color="#F66EB8" inactive-color="#999"
							:active-text="$t('language000363')"></el-switch>
					</div>
					<div class="mt-5">
						<div class="flex justify-between text-sm text-gray-500 mb-2">
							<!-- 电击强度：Electric Shock Intensity -->
							<span>{{ $t('language000438') }}</span><span>{{ electricIntensity }}</span>
						</div><input type="range" v-model.number="electricIntensity" min="0" max="10" class="w-full"
							@input="handleElectricIntensityChange">
					</div>
				</div>

			</div>
		</div>
	</div>
</template>


<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';
	export default {
		name: 'ThrillCage',
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				toyId: '', //传递过来的值 设备ID
				receiverID: '', //传递过来的值 生成链接的ID
				uuid: '', //传递过来的值 uuid 唯一标识
				isConnected: false, //设备是否成功连接

				vibrationEnabled: false,
				vibrationMode: 1,
				vibrationIntensity: 180,

				electricEnabled: false,
				electricMode: 1,
				electricIntensity: 8,

				command: '' //发送给APP的蓝牙命令
			};
		},
		mounted() {
			this.toyId = this.$route.params.toyId; //设备ID
			this.receiverID = this.$route.params.receiverID; //生成链接的ID
			this.uuid = this.$route.params.uuid; //uuid 唯一标识

			const userLanguage = navigator.language || navigator.userLanguage;
			this.$i18n.locale = this.$p_languages.includes(userLanguage) ? userLanguage : this.$p_defaultLanguage;
			this.checkWebUuid();
		},
		methods: {
			getHeaders(includeWebId) {
				const headers = {
					'Content-Type': 'application/json',
					'Accept': '*/*',
					'token': Cookies.get('token')
				};
				if (includeWebId) headers.webId = this.uuid;
				return headers;
			},


			checkWebUuid() {
				axios.post(this.$p_url + '/feign/oemCage/h5/checkWebUuid/' + this.uuid + '/' + this.toyId, {}, {
					withCredentials: true,
					headers: this.getHeaders()
				}).then(response => {
					console.log('校验Oem-ThrillCage外部链接：', response.data);
					if (response.data.state === 'success') this.queryAppConnectStatus();
					else this.open4(this.$t('language000430'));
				}).catch(error => console.error('校验链接失败:', error));
			},
			queryAppConnectStatus() { //检查设备是否连接
				axios.post(this.$p_url + '/feign/oemCage/h5/getAppConnectToyStatus/' + this.toyId, {}, {
					withCredentials: true,
					headers: this.getHeaders()
				}).then(response => {
					console.log('H5查询App是否已连接设备：', response.data);
					if (response.data.state === 'success' && response.data.data.appConnectStatus == 1) {
						this.isConnected = true;
						this.pushMsgToApp('mqtt_h5_100001');
					} else {
						this.isConnected = false;
						this.open4(this.$t('language000429'));
					}
				}).catch(error => console.error('查询设备连接状态失败:', error));
			},

			// 将Android ByteArray转换为协议要求的大写十六进制字符串
			bytesToHex(bytes) {
				return bytes.map(byte => (byte & 255).toString(16).toUpperCase().padStart(2, '0')).join('');
			},
			// 以下组包方法分别对应 ThrillCageHelper.kt 中的同名方法
			buildVibrationCmd(mode, intensity, isVib2 = false, motorId = 0) {
				return this.bytesToHex([0xA0, 0x01, motorId, isVib2 ? 1 : 0, Math.max(1, Math.min(100, mode)), Math.max(0,
					Math.min(255, intensity))]);
			},

			buildStopVibrationCmd(isVib2 = false) {
				return this.bytesToHex([0xA0, 0x02, 0, isVib2 ? 1 : 0, 0, 0]);
			},
			buildElectricShockCmd(enable, mode, intensity) {
				return this.bytesToHex([0xA0, 0x05, enable ? 1 : 0, 0, Math.max(1, Math.min(100, mode)), Math.max(0, Math
					.min(255, intensity))]);
			},
			buildStopElectricShockCmd() {
				return this.buildElectricShockCmd(false, 1, 0);
			},
			selectVibrationMode(mode) {
				this.vibrationMode = mode;
				this.vibrationEnabled = true;
				this.sendVibrationCommand();
			},
			toggleVibration(enabled) {
				if (enabled) this.sendVibrationCommand();
				else this.sendCommand(this.buildStopVibrationCmd());
			},
			sendVibrationCommand() {
				this.sendCommand(this.buildVibrationCmd(this.vibrationMode, this.vibrationIntensity));
			},
			// 震动滑块只在震动开启时发送，关闭状态下仅调整本地参数
			handleVibrationIntensityChange() {
				if (this.vibrationEnabled) this.sendVibrationCommand();
			},
			selectElectricMode(mode) {
				this.electricMode = mode;
				this.electricEnabled = true;
				this.sendElectricCommand();
			},
			toggleElectric(enabled) {
				if (enabled) this.sendElectricCommand();
				else this.sendCommand(this.buildStopElectricShockCmd());
			},
			sendElectricCommand() {
				this.sendCommand(this.buildElectricShockCmd(true, this.electricMode, Math.round(this.electricIntensity /
					10 * 255)));
			},
			// 电击滑块只在电击开启时发送，发送前会在sendElectricCommand中转换强度
			handleElectricIntensityChange() {
				if (this.electricEnabled) this.sendElectricCommand();
			},
			sendCommand(command) {
				this.command = command;
				this.pushMsgToApp('mqtt_h5_100002');
			},
			pushMsgToApp(mqttType) {
				axios.post(this.$p_url + '/feign/oemCage/h5/pushMsgToApp', {
					toyUid: this.toyId,
					receiverID: this.receiverID,
					command: this.command,
					mqttType: mqttType
				}, {
					withCredentials: true,
					headers: this.getHeaders(true)
				}).then(response => console.log('推送给App：', response.data)).catch(error => {
					this.open4(this.$t('language000430'));
					console.error('推送给App失败:', error);
				});
			},
			open4(string) {
				this.$message.error(string);
			}
		}
	};
</script>
<style scoped>
	input[type="range"] {
		width: 100%;
	}
</style>